import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Spinner from '../Spinner';

// Styles
import styles from './Preloader.styl';

const cx = classNames.bind(styles);

export default function Preloader(props) {
  const { className } = props;

  return (
    <div className={cx('Preloader', className)}>
      <Spinner className={cx('Preloader__spinner')} />
    </div>
  );
}

Preloader.defaultProps = {
  className: '',
};

Preloader.propTypes = {
  className: PropTypes.string,
};
